<nav class="d-flex justify-content-end">
  <ul class="pagination">
    <li class="page-item" [ngClass]="{ 'disabled' : pagination.page === 1 }">
      @if (pagination.previousPage === 1) {
        <a class="page-link" [routerLink]="pagination.collectionUrl">
          <span aria-hidden="true">&laquo;</span>
          <span class="visually-hidden">Previous</span>
        </a>
      }
      @if (pagination.previousPage !== 1) {
        <a class="page-link" [routerLink]="pagination.collectionUrl" [queryParams]="{ page: pagination.previousPage }">
          <span aria-hidden="true">&laquo;</span>
          <span class="visually-hidden">Previous</span>
        </a>
      }
    </li>
    @for (page of pagination.pages; track page; let i = $index) {
      <li class="page-item"
        [class.active]="page === pagination.page"
        [class.disabled]="isEllipsis(page)">
        @if (isEllipsis(page)) {
          <span class="page-link">...</span>
        }
        @if (!isEllipsis(page) && pagination.page !== page && page === 1) {
          <a class="page-link" [routerLink]="page.collectionUrl">{{page}}</a>
        }
        @if (!isEllipsis(page) && pagination.page !== page && page !== 1) {
          <a class="page-link" [routerLink]="page.collectionUrl" [queryParams]="{ page: page }">{{page}}</a>
        }
        @if (pagination.page === page) {
          <span class="page-link">{{page}}</span>
        }
      </li>
    }
    <li class="page-item" [ngClass]="{ 'disabled' : pagination.page === pagination.numberOfPages }">
      <a class="page-link" [routerLink]="pagination.collectionUrl" [queryParams]="{ page: pagination.nextPage }">
        <span aria-hidden="true">&raquo;</span>
        <span class="visually-hidden">Next</span>
      </a>
    </li>
  </ul>
</nav>
